// This file must be imported before any other imports in the entry file
// It creates a global process and sets the public path for loading assets

// Add process to window as a global object
declare global {
  interface Window {
    // Using an index signature to avoid conflicts with Node.js types
    // We need this for dynamic properties like __webpack_public_path__ and process
    [key: string]: unknown;
  }
}

// Set up the process global for React
if (typeof window !== 'undefined') {
  // Only run in browser environment
  window.process = window.process || {
    env: {
      NODE_ENV: 'development',
    },
  };

  // Set the public path for dynamic imports for single-spa integration
  // In production, we'll use the current origin (which is the root-config origin)
  // In development, we need to explicitly set to http://localhost:5173/
  const inDev =
    window.location.port === '5173' || process.env.NODE_ENV === 'development';
  window.__webpack_public_path__ = inDev
    ? 'http://localhost:5173/'
    : `${window.location.origin}/`;
}

export {};
